import { withBasePath } from './withBasePath';

type RouterLocation = {
  basePath: string;
  pathname: string;
  query: Record<string, string | string[] | undefined>;
};

/**
 * The href for the current route with `params` set on top of its query, for
 * a raw <a> (such as @latitude/table's getRowHref) that should do what a
 * shallow router.replace of the same params does. Keeps repeated keys and the
 * basePath.
 */
export function buildQueryHref(
  { basePath, pathname, query }: RouterLocation,
  params: Record<string, string>,
): string {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    [value].flat().forEach((entry) => {
      if (entry !== undefined) {
        search.append(key, entry);
      }
    });
  });
  Object.entries(params).forEach(([key, value]) => search.set(key, value));
  return withBasePath(basePath, `${pathname}?${search.toString()}`);
}
